import React from 'react';
import styled from 'styled-components';

export default styled.span`
  ${(props) => props.theme.fonts.parse('sansSerif', 'bold', '14px')}
  display: block;
  margin-bottom: 8px;
  text-transform: uppercase;
`;
